import React from 'react';

import styles from './SavePaymentMethodConsent.module.scss';
import {
  SAVE_PAYMENT_INFO_CONSENT_LABEL,
  SAVE_PAYMENT_INFO_TERMS_LABEL,
  SAVE_PAYMENT_INFO_TERMS_URL,
} from '@/constants/Order';

interface ISavePaymentMethodConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id: string;
}

/**
 * Unchecked stored-credential consent shared by the two authenticated HQ checkouts.
 * Saving is optional and never blocks placing an order.
 */
const SavePaymentMethodConsent = ({ checked, onChange, id }: ISavePaymentMethodConsentProps) => (
  <div className={styles.consent}>
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
      className={styles.checkbox}
    />
    <label htmlFor={id} className={styles.label}>
      {SAVE_PAYMENT_INFO_CONSENT_LABEL}{' '}
      <a
        href={SAVE_PAYMENT_INFO_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        {SAVE_PAYMENT_INFO_TERMS_LABEL}
      </a>
      .
    </label>
  </div>
);

export default React.memo(SavePaymentMethodConsent);
